import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchComments(params) {
  return await request({
    url: ENDPOINT.COMMENT_MANAGEMENT,
    method: "get",
    params,
  });
}


export async function updateCommentStatus(id, data) {
  return await request({
    url: `${ENDPOINT.COMMENT_MANAGEMENT}/${id}`,
    method: "post",
    data,
  });
}
